import loginHooks from './hooks'
import Login from './Login'
import validate from './Validate'

export { loginHooks ,validate}
export default Login